import { ApiError, isVersion } from "./transport";
export function catalogAttachment(
  value: any,
  format: unknown,
): { blob: Blob; filename: string } {
  const manifest = value?.manifest;
  if (
    !manifest ||
    manifest.schemaVersion !== 1 ||
    typeof manifest.shopId !== "string" ||
    !Number.isFinite(Date.parse(manifest.generatedAt)) ||
    !Array.isArray(manifest.listings) ||
    !/^[a-f0-9]{64}$/.test(manifest.manifestDigest) ||
    !manifest.export ||
    typeof manifest.export.id !== "string"
  )
    throw new ApiError("error", "INVALID_EXPORT");
  if (
    !/^[a-f0-9]{64}$/.test(manifest.export.digest) ||
    !["public", "restricted"].includes(manifest.export.access) ||
    Object.keys(manifest.export).some(
      (key) => !["id", "digest", "access"].includes(key),
    )
  )
    throw new ApiError("denied", "INVALID_EXPORT");
  const allowed = new Set([
    "schemaVersion",
    "shopId",
    "generatedAt",
    "listings",
    "export",
    "manifestDigest",
  ]);
  if (Object.keys(manifest).some((key) => !allowed.has(key)))
    throw new ApiError("denied", "INVALID_EXPORT");
  for (const row of manifest.listings) {
    if (
      !row?.listing ||
      typeof row.listing.id !== "string" ||
      !isVersion(row.listing.version) ||
      typeof row.assetLicense !== "string" ||
      (row.careText !== undefined && typeof row.careText !== "string") ||
      Object.keys(row.listing).some(
        (key) => !["id", "version"].includes(key),
      ) ||
      !/^[a-f0-9]{64}$/.test(row.contentDigest) ||
      !/^[a-f0-9]{64}$/.test(row.disclosureDigest) ||
      Object.keys(row).some(
        (key) =>
          ![
            "listing",
            "contentDigest",
            "disclosureDigest",
            "assetLicense",
            "careText",
          ].includes(key),
      )
    )
      throw new ApiError("denied", "INVALID_EXPORT");
  }
  if (format === "csv") {
    if (
      typeof value.csv !== "string" ||
      new TextEncoder().encode(value.csv).length > 8 * 1024 * 1024
    )
      throw new ApiError("error", "INVALID_EXPORT");
    return {
      blob: new Blob([value.csv], { type: "text/csv;charset=utf-8" }),
      filename: "fablelot-catalog.csv",
    };
  }
  if (format !== "json") throw new ApiError("error", "INVALID_EXPORT");
  return {
    blob: new Blob([JSON.stringify(manifest, null, 2)], {
      type: "application/json",
    }),
    filename: "fablelot-catalog.json",
  };
}
/** Local Blob only; never navigate to private/signed server URLs. Caller retains cleanup on unmount. */
export function saveAttachment(file: {
  blob: Blob;
  filename: string;
}): () => void {
  const url = URL.createObjectURL(file.blob);
  let timer: ReturnType<typeof setTimeout>;
  const cleanup = () => {
    clearTimeout(timer);
    URL.revokeObjectURL(url);
  };
  const link = document.createElement("a");
  link.href = url;
  link.download = file.filename;
  document.body.append(link);
  link.click();
  link.remove();
  timer = setTimeout(cleanup, 1000);
  return cleanup;
}
